import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          // '"Pursuing B.Tech at IIIT Jabalpur"',
          // '"Software Developer",',
          // '"Freelancer",',
          '"Passionate Developer"',
          '"Open Source Contributor"',
          '"Efficient Problem Solver"',
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
